module.exports = "mutation DeleteHotlineAnswer($data:DeleteHotlineAnswerInput!){deleteHotlineAnswer(data:$data){success}}"